import fs from 'fs'
import { createReadStream } from 'fs'
import readline from 'readline'
import { ErrorCode } from '@remotekit/shared'
import { RemoteKitError } from '@remotekit/shared'
import { validatePath } from '../security'

export interface LogsHandlerOptions {
  allowedPaths: string[]
  fileBlacklist: string[]
}

export interface StreamContext {
  subscriptionId: string
  emit: (data: any) => void
  onCancel: (fn: () => void) => void
}

export function createLogsHandler(options: LogsHandlerOptions) {
  return {
    'logs:tail': async (params: { path: string; lines?: number; follow?: boolean }, ctx: StreamContext) => {
      if (!params?.path) throw new RemoteKitError(ErrorCode.PATH_DENIED, '缺少 path 参数')
      validatePath(params.path, options.allowedPaths, options.fileBlacklist)

      if (!fs.existsSync(params.path)) {
        throw new RemoteKitError(ErrorCode.FILE_NOT_FOUND, `文件不存在: ${params.path}`)
      }

      const lines = params.lines || 10

      // 读取最后 N 行
      const content = fs.readFileSync(params.path, 'utf-8')
      const allLines = content.split('\n')
      const lastLines = allLines.slice(-lines)
      for (const line of lastLines) {
        ctx.emit(line)
      }

      // follow 模式：监听文件变化
      if (params.follow) {
        let fileSize = fs.statSync(params.path).size
        const watcher = fs.watchFile(params.path, { interval: 500 }, () => {
          const newSize = fs.statSync(params.path).size
          if (newSize > fileSize) {
            const stream = createReadStream(params.path, { start: fileSize, encoding: 'utf-8' })
            const rl = readline.createInterface({ input: stream })
            rl.on('line', (line) => {
              ctx.emit(line)
            })
            rl.on('close', () => {
              fileSize = newSize
            })
          } else if (newSize < fileSize) {
            fileSize = newSize
          }
        })

        ctx.onCancel(() => {
          fs.unwatchFile(params.path)
        })
      }
    },
  }
}
